customElements.define('product-selector', class extends HTMLElement {
	constructor() {
		super();
	}
  
	connectedCallback() {        
		this.selectd_variant = this.querySelector('.selected-variant');
		this.option_items = this.querySelectorAll('.option-item');
		this.variant_json = document.querySelectorAll('.json-item'); 

		this.control_items = this.querySelectorAll('.control-item');
		this.options = this.querySelectorAll('.option-item');

		this.control_items.forEach(e=>{
			e.addEventListener('click' , ()=>{
				this.selectd_variant.innerHTML = e.dataset.title;
				var current_title = e.dataset.title;
				this.control_items.forEach(e=>e.classList.remove('active'));
				e.classList.add('active');
				
				const control_prices = document.querySelectorAll('.control-item-price.variable-price')
				
				
				for (const price of control_prices) {
					let new_price = price.getAttribute('data-price_1');
					// if ( e.dataset.item == 'beach-towels-individual') {
					// 	//change to towel bundle pricing
					// 	new_price = price.getAttribute('data-price_2');
					// }
					price.innerHTML = new_price
				}
				
				
				this.options.forEach(ele=>{
					if (ele.dataset.item == e.dataset.item) {
						ele.classList.remove('none')
						
						const option_selected = ele.querySelector('.option-selected') 
						if ( option_selected == null ) {
							const first_opt = ele.querySelector('.option-value-label') 
							
							first_opt.click()
						}
						
						
					}
					else  ele.classList.add('none')
				})
				
			})
		})

		this.option_items.forEach(e=>{ 
			let option_values = e.querySelectorAll('.option-value-label:not(.disabled)');
          // console.log(option_values);
			option_values.forEach(option=>{
				option.addEventListener('click',()=>{
					// console.log('clicked2')
					
					let new_title = e.closest('.products-wrapper').previousElementSibling.querySelector('.selected-variant');
					// const new_option = option.querySelector('.option-value-input').dataset.colour;
					const current_title = new_title.innerHTML.split('-')[0];
					new_title.innerHTML = `${current_title}`;
					
					const new_img = option.querySelector('.option-image img').getAttribute('data-feature');
					const feautre_img = document.getElementById('bundle-builder-feature');
                    // console.log(new_img)
				
					feautre_img.src = new_img;
					
					
				})
			})
           
		})
	}
	attributeChangedCallback() {
		console.log('Custom square element attributes changed.');
	}
});
  

// ✅ Add event delegation for ALL control-item clicks (works for dynamically added items too)
// document.querySelector('.product-selector-wrapper').addEventListener('click', function (e) {
//     // Find the closest .control-item (if the click happened inside one)
//     const controlItem = e.target.closest('.control-item');
//     if (!controlItem) return; // ignore clicks outside control-item

//     // ✅ Get the image inside the clicked control-item
//     const imgEl = controlItem.querySelector('.control-item-img img');

//     // ✅ Get the image URL and price from data-price_1
//     const imgUrl = imgEl.getAttribute('src');
//     const priceStr = imgEl.getAttribute('data-price_1');
//     const price = parseFloat(priceStr.replace('$', '')) || 0;
// 	console.log(price,"price")

//     // ✅ Log values
//     // console.log("🖼 Image URL:", imgUrl);
//     // console.log("💰 Clicked Price:", price);

//     // ✅ OPTIONAL → Show running total on page
//     window.totalPrice = (window.totalPrice || 0) + price;

//     let totalBox = document.getElementById('grand-total');
//     if (!totalBox) {
//         totalBox = document.createElement('div');
//         totalBox.id = 'grand-total';
//         totalBox.style.fontSize = '18px';
//         totalBox.style.fontWeight = 'bold';
//         totalBox.style.marginTop = '10px';
//         document.body.appendChild(totalBox);
//     }
//     totalBox.innerText = `TOTAL: $${window.totalPrice.toFixed(2)}`;
// });


// -------- helpers --------
function parsePrice(val){ if(!val) return 0; const n=String(val).replace(/[^0-9.\-]/g,''); const f=parseFloat(n); return isNaN(f)?0:f; }
const DISCOUNT_RATE = 0.20; // 20% off
// Build totals UI INSIDE the provided container (.grand-total)
function ensureTotalsUIIn(container){
  if(!container) return null;
  let box = container.querySelector('.grand-totals-inner');
  if(!box){
    box = document.createElement('div');
    box.className = 'grand-totals-inner';
    box.style.cssText = 'font-size:16px;font-weight:600;line-height:1.4;';
    box.innerHTML = `
	<div>Total: <span class="js-compare">—</span></div>
	<div><span class="js-total">—</span></div>
      <div>You save: <span class="js-savings">—</span> <small class="js-savings-pct"></small></div>
    `;
    container.appendChild(box);
  }
  return {
    totalEl:  box.querySelector('.js-total'),
    compEl:   box.querySelector('.js-compare'),
    saveEl:   box.querySelector('.js-savings'),
    pctEl:    box.querySelector('.js-savings-pct')
  };
}

// Recalculate using selected items, write into .grand-total container
function recalcTotals(){
  const totalsContainer = document.querySelector('.grand-total');   // 👈 your blank div
  const ui = ensureTotalsUIIn(totalsContainer);
  if(!ui) { console.warn('Totals container .grand-total not found'); return; }

  const selectedImgs = document.querySelectorAll('.control-item.is-selected .control-item-img img');

  let total = 0, compareTotal = 0;
  selectedImgs.forEach(img=>{
    total        += parsePrice(img.getAttribute('data-price_1') || '0');
    compareTotal += parsePrice(img.getAttribute('data-compare-price') || '0');
  });

  // ---- decide if index 4 is selected ----
const wrapper = document.querySelector('.product-selector-wrapper');
// looks for a selected item inside the product selector with data-index="4"
const sel4 = wrapper && wrapper.querySelector('[data-index="4"] .control-item.is-selected .control-item-img img');
const applyDiscount = !!sel4; // true only when Product 4 has a chosen option

// Prepare base/originals
const originalTotal = total; // sum before discount
if (compareTotal <= 0) compareTotal = originalTotal;
const base = compareTotal > 0 ? compareTotal : originalTotal;

if (!applyDiscount) {
    if(compareTotal === 0) compareTotal = total;

  ui.totalEl.textContent = `$${total.toFixed(2)}`;
  ui.compEl.textContent  = `$${compareTotal.toFixed(2)}`;
  const savings = Math.max(compareTotal - total, 0);
  ui.saveEl.textContent = `$${savings.toFixed(2)}`;
  ui.pctEl.textContent  = (savings>0 && compareTotal>0)
    ? `${Math.round((savings/compareTotal)*100)}% off`
    : '';
} else {
 const originalTotal = total; // sum of selected (before discount)
if (compareTotal < 0) compareTotal = 0;

// Use compare price if present, else original subtotal
const base = compareTotal > 0 ? compareTotal : originalTotal;
// 20% off the original subtotal
const discountedTotal = Math.max(originalTotal * (1 - DISCOUNT_RATE), 0);
// "Minus" price (difference to display)
const minusPrice = Math.max(originalTotal - discountedTotal, 0);

// Write UI
ui.compEl.textContent  = `$${compareTotal.toFixed(2)}`; 
ui.totalEl.textContent = `$${discountedTotal.toFixed(2)}`; 
const savings = Math.max(compareTotal - discountedTotal, 0);
 ui.saveEl.textContent = `$${savings.toFixed(2)}`; 
ui.pctEl.textContent   = `${Math.round((minusPrice / base) * 100)}% off`;
}

//   if(compareTotal === 0) compareTotal = total;

//   ui.totalEl.textContent = `$${total.toFixed(2)}`;
//   ui.compEl.textContent  = `$${compareTotal.toFixed(2)}`;
//   const savings = Math.max(compareTotal - total, 0);
//   ui.saveEl.textContent = `$${savings.toFixed(2)}`;
//   ui.pctEl.textContent  = (savings>0 && compareTotal>0)
//     ? `${Math.round((savings/compareTotal)*100)}% off`
//     : '';


}
// Click handling (optional: still uses .product-selector-wrapper if you have it)
(function init(){
  const wrapper = document.querySelector('.product-selector-wrapper');
  if(wrapper){
    wrapper.addEventListener('click', function(e){
		console.log()
      const controlItem = e.target.closest('.control-item');
      if(!controlItem || !this.contains(controlItem)) return;

      const group = controlItem.closest('.control-list') || controlItem.parentElement;
      group.querySelectorAll('.control-item.is-selected').forEach(el=>el.classList.remove('is-selected'));
      controlItem.classList.add('is-selected');

      recalcTotals();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', recalcTotals);
  } else {
    recalcTotals();
  }
})();

